<template>
  <div>
    <div class="toolbar">
      <el-select v-model="itemTypeId" clearable filterable placeholder="工序阶段" style="width:160px" @change="load">
        <el-option v-for="d in itemTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
      </el-select>
      <el-input v-model="keyword" clearable placeholder="工序名称" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增工序</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="{ $index }">{{ (page - 1) * pageSize + $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="itemTypeName" label="工序阶段" width="110" />
      <el-table-column prop="name" label="工序名称" min-width="130" />
      <el-table-column prop="itemContent" label="通知内容" min-width="180" show-overflow-tooltip />
      <el-table-column prop="sortNo" label="排序" width="70" />
      <el-table-column prop="enabled" label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled === 1 ? 'success' : 'info'">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id ? '编辑工序' : '新增工序'" :visible.sync="visible" width="760px" top="4vh">
      <el-form :model="form" label-width="100px" v-loading="metaLoading">
        <el-form-item label="工序阶段" required>
          <el-select v-model="form.itemTypeId" filterable clearable placeholder="请选择" style="width:100%">
            <el-option v-for="d in itemTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="工序名称" required>
          <el-input v-model="form.name" maxlength="64" placeholder="工序名称" />
        </el-form-item>

        <div class="section-block">
          <div class="section-title">发通知</div>
          <el-form-item label="接收人">
            <div class="switch-row">
              <el-switch v-model="form.isAllReceiver" :active-value="1" :inactive-value="0" /> 全部项目成员
              <el-switch v-model="form.receiverHaveCustomer" :active-value="1" :inactive-value="0" style="margin-left:16px" /> 客户
            </div>
            <el-select
              v-model="form.receiverRoleIdList"
              multiple
              filterable
              clearable
              placeholder="选择角色"
              style="width:100%;margin-top:8px"
              :disabled="form.isAllReceiver===1"
            >
              <el-option v-for="r in roles" :key="r.id" :label="r.roleName" :value="r.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="到场人">
            <div class="switch-row">
              <el-switch v-model="form.isAllPresenter" :active-value="1" :inactive-value="0" /> 全部项目成员
              <el-switch v-model="form.presenterHaveCustomer" :active-value="1" :inactive-value="0" style="margin-left:16px" /> 客户
            </div>
            <el-select
              v-model="form.presenterRoleIdList"
              multiple
              filterable
              clearable
              placeholder="选择角色"
              style="width:100%;margin-top:8px"
              :disabled="form.isAllPresenter===1"
            >
              <el-option v-for="r in roles" :key="r.id" :label="r.roleName" :value="r.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="确认人">
            <div class="switch-row">
              <el-switch v-model="form.isAllConfirmer" :active-value="1" :inactive-value="0" /> 全部项目成员
              <el-switch v-model="form.confirmerHaveCustomer" :active-value="1" :inactive-value="0" style="margin-left:16px" /> 客户
            </div>
            <el-select
              v-model="form.confirmerRoleIdList"
              multiple
              filterable
              clearable
              placeholder="选择角色"
              style="width:100%;margin-top:8px"
              :disabled="form.isAllConfirmer===1"
            >
              <el-option v-for="r in roles" :key="r.id" :label="r.roleName" :value="r.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="通知内容">
            <el-input
              v-model="form.itemContent"
              type="textarea"
              :rows="3"
              :placeholder="'发起通知时的默认内容，可用 {{项目名称}}（发送时替换为项目名称）'"
            />
          </el-form-item>
        </div>

        <div class="section-block">
          <div class="section-title">选工人</div>
          <el-form-item label="工种">
            <el-select v-model="form.workerTypeIdList" multiple filterable clearable placeholder="工种" style="width:100%">
              <el-option v-for="d in workerTypes" :key="d.id" :label="d.dictLabel" :value="d.id" />
            </el-select>
          </el-form-item>
        </div>

        <div class="section-block">
          <div class="section-title">客户评价</div>
          <el-form-item label="评价模板">
            <el-select
              v-model="form.evaluateTplIdList"
              multiple
              filterable
              clearable
              placeholder="可多选评价模板"
              style="width:100%"
            >
              <el-option v-for="t in evaluateTpls" :key="t.id" :label="t.name" :value="t.id" />
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="排序">
          <el-input-number v-model="form.sortNo" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listStageDefs, saveStageDef, deleteStageDef, listEvaluateTplOptions } from '../../api/project'
import { listDictOptions } from '../../api/dict'
import { listRoles } from '../../api/sys'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

function emptyForm(sortNo) {
  return {
    id: null,
    name: '',
    itemTypeId: null,
    itemContent: '',
    receiverRoleIdList: [],
    isAllReceiver: 0,
    receiverHaveCustomer: 0,
    presenterRoleIdList: [],
    isAllPresenter: 0,
    presenterHaveCustomer: 0,
    confirmerRoleIdList: [],
    isAllConfirmer: 0,
    confirmerHaveCustomer: 0,
    evaluateTplIdList: [],
    workerTypeIdList: [],
    sortNo: sortNo || 0,
    enabled: 1,
    remark: ''
  }
}

function parseIds(csv) {
  if (!csv) return []
  return String(csv).split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !Number.isNaN(n))
}

function joinIds(arr) {
  return (arr && arr.length) ? arr.join(',') : ''
}

export default {
  name: 'StageDef',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      itemTypeId: null,
      list: [],
      loading: false,
      visible: false,
      saving: false,
      metaLoading: false,
      form: emptyForm(0),
      itemTypes: [],
      workerTypes: [],
      roles: [],
      evaluateTpls: []
    }
  },
  created() {
    this.loadItemTypes()
    this.load()
  },
  methods: {
    async loadItemTypes() {
      const res = await listDictOptions('PROJECT_ITEM_TYPE')
      this.itemTypes = (res && res.data) || []
    },
    async loadMeta() {
      this.metaLoading = true
      try {
        const [types, workers, roles, tpls] = await Promise.all([
          listDictOptions('PROJECT_ITEM_TYPE'),
          listDictOptions('WORKER_TYPE'),
          listRoles(),
          listEvaluateTplOptions()
        ])
        this.itemTypes = (types && types.data) || []
        this.workerTypes = (workers && workers.data) || []
        this.roles = ((roles && roles.data) || [])
        this.evaluateTpls = (tpls && tpls.data) || []
      } finally {
        this.metaLoading = false
      }
    },
    async load() {
      this.loading = true
      try {
        const res = await listStageDefs({
          keyword: this.keyword || undefined,
          itemTypeId: this.itemTypeId || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async openEdit(row) {
      await this.loadMeta()
      if (!row) {
        this.form = emptyForm((this.list.length + 1) * 10)
      } else {
        this.form = {
          ...emptyForm(0),
          ...row,
          receiverRoleIdList: parseIds(row.receiverRoleIds),
          presenterRoleIdList: parseIds(row.presenterRoleIds),
          confirmerRoleIdList: parseIds(row.confirmerRoleIds),
          workerTypeIdList: parseIds(row.workerTypeIds),
          isAllReceiver: row.isAllReceiver || 0,
          receiverHaveCustomer: row.receiverHaveCustomer || 0,
          isAllPresenter: row.isAllPresenter || 0,
          presenterHaveCustomer: row.presenterHaveCustomer || 0,
          isAllConfirmer: row.isAllConfirmer || 0,
          confirmerHaveCustomer: row.confirmerHaveCustomer || 0,
          evaluateTplIdList: parseIds(row.evaluateTplIds)
        }
      }
      this.visible = true
    },
    async save() {
      const f = this.form
      if (!f.itemTypeId) return this.$message.warning('请选择工序阶段')
      if (!f.name) return this.$message.warning('请填写工序名称')
      const payload = {
        id: f.id,
        name: f.name,
        itemTypeId: f.itemTypeId,
        itemContent: f.itemContent || '',
        receiverRoleIds: joinIds(f.receiverRoleIdList),
        isAllReceiver: f.isAllReceiver,
        receiverHaveCustomer: f.receiverHaveCustomer,
        presenterRoleIds: joinIds(f.presenterRoleIdList),
        isAllPresenter: f.isAllPresenter,
        presenterHaveCustomer: f.presenterHaveCustomer,
        confirmerRoleIds: joinIds(f.confirmerRoleIdList),
        isAllConfirmer: f.isAllConfirmer,
        confirmerHaveCustomer: f.confirmerHaveCustomer,
        confirmReceiverRoleIds: '',
        isAllConfirmReceiver: 0,
        confirmReceiverHaveCustomer: 0,
        evaluateTplIds: joinIds(f.evaluateTplIdList),
        isMaterialApply: 0,
        isStart: 0,
        isEnd: 0,
        isNodeEnd: 0,
        isUploadPic: 0,
        workerTypeIds: joinIds(f.workerTypeIdList),
        sortNo: f.sortNo,
        enabled: f.enabled,
        remark: f.remark
      }
      this.saving = true
      try {
        await saveStageDef(payload)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除工序「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteStageDef(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.switch-row { display:flex; align-items:center; flex-wrap:wrap; gap:4px; color:#475569; font-size:13px; }
.section-block {
  margin: 8px 0 18px;
  padding: 12px 14px 4px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}
.section-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}
</style>
